import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { RadioButton } from './index'
import { SelectOption } from 'types/common'

type Props = {
  currentStatus: string
  options: SelectOption[]
  handleStatus: (event: ChangeEvent<HTMLInputElement>) => void
}

const RadioButtonsForm: FC<Props> = (props) => {
  const { currentStatus, options, handleStatus } = props
  return (
    <div>
      <div className={styles.column_two}>
        {options.map((option) => (
          <div className={styles.column_two__item} key={option.value}>
            <RadioButton
              isChecked={currentStatus === option.value}
              label={option.label}
              onChange={handleStatus}
              value={option.value}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default RadioButtonsForm
